var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_432_1500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4153 8.62958H18.0882V15.1158H14.4153V8.62958ZM8.16354 8.62958H11.8365V15.1158H8.16354V8.62958ZM18.7916 16.288H1.20843C0.562077 16.288 0.0362244 16.8139 0.0362244 17.4602V18.8278C0.0362244 19.4742 0.562077 20 1.20843 20H18.7916C19.4379 20 19.9638 19.4742 19.9638 18.8278V17.4602C19.9638 16.8139 19.4379 16.288 18.7916 16.288ZM19.2292 3.67993L10.4354 0.0842527C10.1568 -0.0272244 9.84707 -0.0294907 9.5605 0.0858938L0.770809 3.67993C0.324471 3.85951 0.0362244 4.28612 0.0362244 4.76739V6.2852C0.0362244 6.93156 0.562077 7.45741 1.20843 7.45741H18.7916C19.4379 7.45741 19.9638 6.93156 19.9638 6.2852V4.76739C19.9638 4.28612 19.6755 3.85951 19.2292 3.67993ZM10.5861 4.37055C10.5861 4.69424 10.3237 4.95666 10 4.95666C9.67632 4.95666 9.4139 4.69424 9.4139 4.37055V3.1202C9.4139 2.79651 9.67632 2.53409 10 2.53409C10.3237 2.53409 10.5861 2.79651 10.5861 3.1202V4.37055ZM1.91176 8.62958H5.58468V15.1158H1.91176V8.62958Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_432_1500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.f090bf5a6093f03f84349e5440531c6b.svg";
export { ForwardRef as ReactComponent };